import axiosClient from '../axiosClient';

export const getSettings = (key) =>
  axiosClient.get('/admin/settings', { params: { key } });

export const updateSettings = (key, value) =>
  axiosClient.put('/admin/settings', { key, value });

export const getPaymentGateways = () =>
  axiosClient.get('/admin/settings/payment-gateways');

export const updatePaymentGateway = (code, data) =>
  axiosClient.put(`/admin/settings/payment-gateways/${code}`, data);

export const getCurrencies = () =>
  axiosClient.get('/admin/settings/currencies');

export const updateCurrencies = (data) =>
  axiosClient.put('/admin/settings/currencies', data);

export const getNotificationTemplates = () =>
  axiosClient.get('/admin/settings/notification-templates');

export const updateNotificationTemplate = (id, data) =>
  axiosClient.put(`/admin/settings/notification-templates/${id}`, data);

export const testNotification = (id, data) =>
  axiosClient.post(`/admin/settings/notification-templates/${id}/test`, data);
